module.exports = __webpack_public_path__ + "static/favicon-40c2309038e5354701b0b103e1d86e1e.ico";